
import { common } from './common/ko';
import { products } from './products/ko';
import { pricing } from './pricing/ko';
import { solutions } from './solutions/ko';

export const ko = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
